import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Tab
 * */
export default class Tab extends PureComponent {
  static propTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    /** tab值 */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    /** 序号 */
    index: PropTypes.number,
    /** 选中回调 */
    onSelect: PropTypes.func,
    /** 是否选中 */
    selected: PropTypes.bool,
    /** 是否禁用 */
    disabled: PropTypes.bool,
    /** 是否撑满宽度 */
    fullWidth: PropTypes.bool,
    /** 尺寸 */
    size: PropTypes.oneOf(['large', 'medium', 'small']),
  };

  static defaultProps = {
    prefixCls: 'ne-tab',
    selected: false,
    disabled: false,
    fullWidth: false,
    size: 'medium',
  };

  getEl = el => {
    this.el = el;
  };

  onClick = e => {
    const { disabled, value, onSelect, onClick, index } = this.props;
    if (!disabled) {
      onSelect && onSelect(e, value != null ? value : index);
    }
    onClick && onClick(e);
  };

  onKeyDown = event => {
    const { onKeyDown } = this.props;
    const { key } = event;
    if (!this.keyDown && key === ' ') {
      this.keyDown = true;
      event.persist();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
    if (event.target === this.el && (key === ' ' || key === 'Enter')) {
      event.preventDefault();
      this.onClick(event);
    }
  };

  onKeyUp = event => {
    if (event === ' ') {
      this.keyDown = false;
      event.persist();
    }
    const { onKeyUp } = this.props;
    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  render() {
    const {
      className,
      index,
      disabled,
      prefixCls,
      value,
      selected,
      fullWidth,
      size,
      children,
      ...other
    } = this.props;
    const classes = classNames(
      prefixCls,
      {
        [`${prefixCls}-full-width`]: fullWidth,
        [`${prefixCls}-selected`]: !disabled && selected,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-${size}`]: size,
      },
      className,
    );
    return (
      <div
        {...other}
        onKeyDown={this.onKeyDown}
        onKeyUp={this.onKeyUp}
        ref={this.getEl}
        tabIndex={disabled ? -1 : 0}
        role="tab"
        className={classes}
        onClick={this.onClick}
        aria-selected={selected}>
        <div className={`${prefixCls}-text`}>{children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tabs/Tab.jsx